import React, { useState, useEffect } from 'react';

export default (WrappedComponent) => {
  const Geolocation = (props) => {
    const [geoLocationIsLoading, setGeoLocationIsLoading] = useState(false);
    const [coords, setCoords] = useState(null);
    const [geoLocationError, setGetLocationError] = useState(null);

    var _isMounted = false;

    useEffect(() => {
      _isMounted = true;
      setGeoLocationIsLoading(true);

      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            if (_isMounted) {
              setGeoLocationIsLoading(false);
              setCoords(position.coords);
            }
          },
          (error) => {
            if (_isMounted) {
              setGeoLocationIsLoading(false);
              setGetLocationError(error);
            }
          }
        );
      } else {
        setGeoLocationIsLoading(false);
        setGetLocationError(true);
        //this.error('Vi kunde inte hitta din position välj istället ditt län i listan nedan');
      }
    }, []);

    useEffect(() => {
      return () => {
        _isMounted = false;
      };
    }, []);

    return (
      <WrappedComponent
        {...props}
        geoLocationIsLoading={geoLocationIsLoading}
        coords={coords}
        geoLocationError={geoLocationError}
      />
    );
  };

  return Geolocation;
};
